<template>
  <div>
    <div class="i-total-calendar-container">
      <div class="i-total-calendar-title">
        <v-btn
          fab
          text
          small
          color="grey darken-2"
          @click="prev"
        >
          <v-icon small>
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <div
          class="i-total-calendar-title-text"
          @click="handleTitleClick"
        >
          {{ calendarTitle }}
        </div>
        <v-spacer></v-spacer>
        <v-btn
          fab
          text
          small
          color="grey darken-2"
          @click="next"
        >
          <v-icon small>
            mdi-chevron-right
          </v-icon>
        </v-btn>
      </div>

      <!-- -->
      <v-calendar
        v-if="mode === 'month' || mode === 'twomonth' || (!mode === 'twomonth' && !mode === 'week')"
        ref="vuetifyCalendarMonthly"
        v-model="today"
        :value="today"
        :now="today"
        :class="calendarClass"
        color="primary"
        type="month"
        :weekday-format="myDayFormat"
        @click:date="dateClick"
      >
        <template v-slot:day-label="dayObj">
          <!-- v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--small primary -->
          <!-- {{ moment(today).month()+1 }}
          {{ dayObj.month }} -->
          <v-btn
            v-if="(moment(today).month()+1) === (dayObj.month)"
            fab
            rounded
            small
            elevation="0"
            :color="getDayColor(dayObj)"
            class="transparent"
            :text="isText(dayObj)"
            @click="handleDateClick(dayObj)"
          >
            {{ dayObj.day }}
          </v-btn>
        </template>
        <template v-slot:day="weekObj">
          <slot
            name="day"
            :weekObj="weekObj"
          ></slot>
        </template>
      </v-calendar>
      <v-calendar
        v-if="mode === 'twomonth'"
        ref="vuetifyCalendarNextMonth"
        v-model="nextMonth"
        :value="nextMonth"
        :now="today"
        hide-header
        :class="calendarClass"
        color="primary"
        type="month"
        :weekday-format="myDayFormat"
        @click:date="dateClick"
      >
        <template v-slot:day-label="dayObj">
          <!-- v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--small primary -->
          <!-- {{ moment(nextMonth).month()+1 }}
          {{ dayObj.month }} -->
          <v-btn
            v-if="(moment(nextMonth).month()+1) === (dayObj.month)"
            fab
            rounded
            small
            elevation="0"
            :color="getDayColor(dayObj)"
            class="transparent mb-1"
            :text="isText(dayObj)"
            @click="handleDateClick(dayObj)"
          >
            {{ dayObj.day }}
          </v-btn>
        </template>
        <template v-slot:day="weekObj">
          <slot
            name="day"
            :weekObj="weekObj"
          ></slot>
        </template>
      </v-calendar>
      <!-- -->
      <v-calendar
        v-if="mode === 'week'"
        ref="vuetifyCalendarWeekly"
        v-model="today"
        :value="today"
        :now="today"
        class="i-total-calendar"
        color="primary"
        type="week"
        :weekday-format="myDayFormat"
        @click:date="dateClick"
      >
        <template v-slot:day-label-header="dayObj">
          <!-- v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--small primary -->
          <v-btn
            fab
            rounded
            small
            elevation="0"
            :color="getDayColor(dayObj)"
            class="transparent mb-1"
            :text="isText(dayObj)"
            @click="handleDateClick(dayObj)"
          >
            {{ dayObj.day }}
          </v-btn>
        </template>
      </v-calendar>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted, computed, toRefs } from 'vue'
import moment from '@/utils/moment'

const props = defineProps({
  mode: {
    type: String,
    default: 'week',
  },
  noBorder: {
    type: Boolean,
    default: true,
  },
  dateClick: {
    type: Function,
    default() {
      return dateInfo => {
        console.log('dateInfo', dateInfo)
      }
    },
  },
  highlight: {
    type: Array,
    default: () => [
      // '2023-04-13',
    ],
  },
  highlightColor: {
    type: String,
    default: 'info',
  },
})
const { mode, highlight, highlightColor, dateClick, noBorder } = toRefs(props)

const calendarClass = computed(() => {
  let className = 'i-total-calendar'
  if (noBorder.value) {
    className += ' no-border'
  }

  return className
})

function isText(dayObj) {
  if (highlight.value.includes(dayObj.date)) {
    return false
  }
  if (dayObj.present) {
    return false
  }

  return true
}

function getDayColor(dayObj) {
  // console.log('dayObj', dayObj)
  if (dayObj.present && mode.value === 'week') {
    return 'error'
  }
  if (highlight.value.includes(dayObj.date)) {
    return highlightColor.value
  }

  if (dayObj.date) { return 'grey darken-2' }
}

const myDayFormat = ref(day => {
  const weekdayNames = ['S', 'M', 'T', 'W', 'T', 'F', 'S']

  // console.log('myDayFormat day', day)

  return weekdayNames[day.weekday]
})
const calendarConfigs = reactive({
  sundayStart: true,
  dateFormat: 'yyyy-MM-DD',
  isDatePicker: false,
  isDateRange: false,
})

// const weekdays = ref([])
const selectedItem = ref(1)
const today = ref(moment().format(calendarConfigs.dateFormat))

// const getNextMonth = () => moment(today.value).add(1, 'month').format(calendarConfigs.dateFormat)
function getNextMonth() {
  return moment(today.value).add(1, 'month').format(calendarConfigs.dateFormat)
}
const nextMonth = ref(getNextMonth())

const canlendar = ref(null)
const vuetifyCalendarWeekly = ref(null)
const vuetifyCalendarMonthly = ref(null)
const vuetifyCalendarNextMonth = ref(null)

const calendarTitle = computed(() => moment(today.value).format('yyyy-MM'))

const emit = defineEmits(['titleClick', 'prev', 'next'])
function prev() {
  if (mode.value === 'week') {
    // const prevDate =

    // console.log('moment', prevDate)
    today.value = moment(today.value).add(-7, 'days').format(calendarConfigs.dateFormat)
  } else {
    // console.log('moment', prevDate)
    today.value = moment(today.value).add(-1, 'months').format(calendarConfigs.dateFormat)
    nextMonth.value = getNextMonth()
  }

  emit('prev', { date: today.value })
}
function next() {
  if (mode.value === 'week') {
    const nextDate = moment(today.value).add(7, 'days').format(calendarConfigs.dateFormat)

    // console.log('moment', prevDate)
    today.value = nextDate
  } else {
    today.value = getNextMonth()
    nextMonth.value = getNextMonth()
  }

  emit('next', { date: today.value })
}

function handleTitleClick() {
  console.log('handleTitleClick')

  // if (mode.value === 'week') {

  // }
  emit('titleClick')
}
function handleDateClick(dayObj) {
  today.value = moment(dayObj.date).format(calendarConfigs.dateFormat)
  dateClick.value(dayObj)
}
</script>
<style scoped>
.dayClass {
  max-width: 100px;
  max-height: 100px;
  overflow: hidden;
}

.i-total-calendar-container {
  color: var(--gray-900);
  border: 1px solid;
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-top-style: solid;
  border-right-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-color: #cbd5e0;
  border-radius: 0.5rem !important;
}
</style>
<style>

.itotal-vc-weekday {
  color: #a0aec0;
  font-size: 14px;
  font-weight: 700;
}
.i-total-calendar .v-outside.v-calendar-weekly__day .v-calendar-weekly__day-label{
  /* height: 0px !important; */
  display: none!important;;
}

.i-total-calendar .v-calendar-daily__intervals-head,.v-calendar-daily__interval-text,.v-calendar-daily__body {
  display: none !important;
}

.i-total-calendar .v-calendar-daily__interval-text {
  display: none !important;
}

.i-total-calendar .v-calendar-daily__body {
  display: none !important;
}

.i-total-calendar .v-btn--fab.v-size--default {
  width: 28px;
  height: 28px;
}

.i-total-calendar .v-calendar-weekly__head{
  border-bottom: rgba(93, 89, 98, 0.1) 1px solid;
}

.i-total-calendar.no-border .v-calendar-weekly__day,
.v-calendar-daily_head-day,
.v-calendar-weekly__head-weekday {
  border-bottom: 0px !important;
  border-right: 0px !important;
}

.i-total-calendar {
  /* border-left: 0px !important;
  border-top: 0px !important; */
  border-color: #cbd5e0;
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-right-radius: 0.5rem !important;
}
.i-total-calendar.no-border {
  border-left: 0px !important;
  border-top: 0px !important;
}

.i-total-calendar-title {
  display: flex;
  background-color: white;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.i-total-calendar-title .v-icon {
  font-size: 30px !important;
}

.i-total-calendar-title-text {
  padding-top: 10px;
  font-size: 18px;
  color: #2d3748;
  font-weight: 600;
  line-height: 28px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  white-space: nowrap;
}

.i-total-calendar .v-calendar-daily_head-weekday,.v-calendar-weekly__head-weekday {
  color: #a0aec0 !important;
  font-size: 14px;
  font-weight: 700;
}
</style>
